export default __webpack_public_path__ + "static/media/art-0-clearing.48f5fd8f.jpeg";